module.exports = __webpack_public_path__ + "static/img/step.fc7b6ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/step.png
// module id = 7l0a
// module chunks = 0